import React from 'react'
import Partnerships from './templates/Partnerships/Partnerships'
import Technology from './templates/Technology/Technology'
import Applications from './templates/Applications/Applications'
import HomePage from './templates/HomePage/HomePage'
import Careers from './templates/Careers/Careers'
import EPP from './templates/EPP/EPP'
import About from './templates/About/About'
import Resources from './templates/Resources/Resources'
import ContactUs from './templates/ContactUs/ContactUs'
import NotFound from './templates/NotFound'
import Position from './templates/Position/Position'

import { Color } from './utils/constants'
import PositionForm from './templates/Position/PositionForm'
import PrivacyPolicy from './templates/PrivacyPolicy'
import ResourceWrapper from './templates/Resources/components/ResourceWrapper'
import EuGrants from './templates/EuGrants'

export interface Page {
  path: string
  element: React.ReactNode
  title?: string
  parent?: string
  color?: Color
  external?: boolean
}

function Redirect() {
    window.open('https://careers.biomatter.ai/', '_blank')
    return null
}

const pages: Page[] = [
    {
        path: '/',
        element: <HomePage />,
        color: Color.PURPLE,
    },
    {
        path: 'lynx',
        element: <EPP />,
        title: 'page.epp',
        parent: 'page.offerings',
        color: Color.PURPLE,
    },
    {
        path: 'partnerships',
        element: <Partnerships />,
        title: 'page.partnerships.new',
        parent: 'page.offerings',
        color: Color.GREEN_LIGHT,
    },
    {
        path: 'technology',
        element: <Technology />,
        title: 'page.technology',
        parent: 'page.platform',
        color: Color.GREEN_LIGHT,
    },
    {
        path: 'applications',
        element: <Applications />,
        title: 'page.applications',
        parent: 'page.platform',
        color: Color.GREEN_LIGHT,
    },
    {
        path: 'https://careers.biomatter.ai/',
        element: <Redirect />,
        title: 'page.careers',
        color: Color.PURPLE,
        external: true,
    },
    // {
    //     path: 'careers',
    //     element: <Careers />,
    //     title: 'page.careers',
    //     color: Color.PURPLE,
    // },
    // {
    //     path: 'careers/:positionId',
    //     element: <Position />,
    //     color: Color.PURPLE_LIGHT,
    // },
    // {
    //     path: 'careers/:positionId/apply',
    //     element: <PositionForm />,
    //     color: Color.PURPLE_LIGHT,
    // },
    {
        path: 'about',
        element: <About />,
        title: 'page.about',
        parent: 'page.company',
        color: Color.PURPLE,
    },
    {
        path: 'resources',
        element: <Resources />,
        title: 'page.resources',
        parent: 'page.company',
        color: Color.SAND,
    },
    {
        path: 'resources/:category',
        element: <Resources />,
        color: Color.SAND,
    },
    {
        path: 'resources/:category/:resourceId',
        element: <ResourceWrapper />,
        color: Color.WHITE,
    },
    {
        path: 'eu-grants',
        element: <EuGrants />,
        title: 'page.euGrants',
        parent: 'page.company',
        color: Color.WHITE,
    },
    {
        path: 'contact',
        element: <ContactUs />,
        color: Color.PURPLE,
    },
    {
        path: 'privacy',
        element: <PrivacyPolicy />,
        color: Color.WHITE,
    },
    {
        path: '*',
        element: <NotFound />,
        color: Color.SAND,
    },
]

export const footerPages = [
    {
        title: 'page.company',
        pages: [
            {
                title: 'page.about',
                path: 'about',
            },
            {
                title: 'page.resources',
                path: 'resources',
            },
            {
                path: 'eu-grants',
                title: 'page.euGrants',
            },
        ],
    },
    {
        title: 'page.platform',
        pages: [
            {
                title: 'page.technology',
                path: 'technology',
            },
            {
                title: 'page.applications',
                path: 'applications',
            },
        ],
    },
    {
        title: 'page.reachOut',
        pages: [
            {
                title: 'page.partnerships',
                path: 'partnerships',
            },
            {
                title: 'page.contactUs',
                path: 'contact',
            },
            {
                title: 'page.careers',
                path: 'https://careers.biomatter.ai/',
                external: true,
            },
            // {
            //     title: 'page.careers',
            //     path: 'careers',
            // },
        ],
    },
]

export default pages
